// * FETCH
export const FETCH_USER_RESET = 'employee/FETCH_USER_RESET';

// * POST
export const POST_USER_RESET = 'employee/POST_USER_RESET';
